import React, {useState} from 'react'
import PropTypes from 'prop-types'
import './helppopup.css'

export default function HelpPopup(props){
	return(
		<div className={"popup"}>
			<h3>Help & FAQ</h3>
			<HelpContainer
				question={"How do you save samples for DairyComp software?"}
			>
				<ol>
					<li>DairyComp is only downloadable for Individual and Herd report types</li>
					<li>Once your samples are displayed, then click the button titled "Save As DairyComp" above the samples</li>
					<li>Upon downloading, you will see the download popup as "HERDCODE.dnq". Depending on your browser this will be in different locations.</li>
					<li>In your computer's folder's page, find the newly downloaded file.</li>
					<li>Rename the file to your 8-digit Herd ID</li>
					<li>The file is now ready to be uploaded into your DairyComp software</li>
				</ol>
			</HelpContainer>
		</div>
	)
}

function HelpContainer(props){
	let [showHidden, toggleHidden] = useState(false)
	
	const hiddenContainer = showHidden && (
		<div className={"popup-help-hidden-container"}>
			{props.answer}
			{props.children}
		</div>
	)
	
	return(
		<div className={"popup-help-container"}>
			<a onClick={() => toggleHidden(!showHidden)}>{props.question}</a>
			{hiddenContainer}
		</div>
	)
}

HelpContainer.propTypes = {
	question: PropTypes.string.isRequired,
	answer: PropTypes.string
}